<template>
    <div class="col-md-12 px-0 py-0">
        <div class="col-md-12 text-right text-success">
            <span style="font-size: 20px">Modelo de negocio</span>
        </div>
        <form action="" method="post" class="form-horizontal mt-5">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Titulo</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="title"
                        class="form-control"
                        placeholder="Titulo"
                    />
                    <span v-if="allerrors.title" :class="['show-error']">{{
                        allerrors.title[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Indicación</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="indication"
                        class="form-control"
                        placeholder="Indicación"
                    />
                    <span v-if="allerrors.indication" :class="['show-error']">{{
                        allerrors.indication[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" @click="update()" class="btn btn-primary">
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            title: null,
            indication: null,
            arrayColors: [],
            allerrors: {
                title: null,
                indication: null,
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/project-sections?type=modelo%20negocio")
                .then(function (response) {
                    me.title = response.data.title;
                    me.indication = response.data.indication;
                    me.clearError();
                })
                .catch(function (error) {});
        },

        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(
                        "/admin/project-section/business-model/update/" +
                            me.model_id,
                        {
                            title: me.title,
                            indication: me.indication,
                        }
                    )
                    .then(function (response) {
                        me.image_path = response.data.image_path;
                        me.clearError();
                        me.showActionSuccess();
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.title) {
                me.allerrors.title = ["El campo titulo es obligatorio."];
                valid = false;
            } else if (me.title.length > 50) {
                me.allerrors.title = [
                    "El campo titulo debe tener máximo 50 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.title = [""];
            }

            if (!me.indication) {
                me.allerrors.indication = [
                    "El campo indicación es obligatorio.",
                ];
                valid = false;
            } else if (me.indication.length > 50) {
                me.allerrors.indication = [
                    "El campo indicación debe tener máximo 50 caraccteres",
                ];
                valid = false;
            } else {
                me.allerrors.indication = [""];
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                title: null,
                indication: null,
            };
        },
        showActionSuccess() {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: "Actualizacion exitosa!",
            });
        },
    },
    mounted() {
        let me = this;
        me.getModel();
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
